import {isNumber, isArray} from 'lodash';

export default function opacifyStyle(
    opacity: number,
    style: mapboxgl.Style | undefined
): mapboxgl.Style | undefined {

    if (!style || !style.layers) {
        return style;
    }
    return {
        ...style,
        layers: style.layers.map((layer: mapboxgl.Layer) => ({
            ...layer,
            paint: opacifyPaintProperties(opacity, layer.type, layer.paint)
        }))
    };
}

function opacifyPaintProperties(opacity: number, type: mapboxgl.Layer['type'], paint: any = {}) {
    if (type === 'symbol') {
        return {
            ...paint,
            'text-opacity': opacify('opacity', paint['text-opacity'], opacity),
            'icon-opacity': opacify('opacity', paint['icon-opacity'], opacity)
        };

    } else if (type === 'hillshade') {
        return {
            ...paint,
            'hillshade-exaggeration': opacify(
                'exaggeration',
                paint['hillshade-exaggeration'],
                opacity
            )
        };
    } else {
        const key = type + '-opacity';
        return {
            ...paint,
            [key]: opacify('opacity', paint[key], opacity),
        };
    }
}


function opacify(
    property: string,
    value: number | mapboxgl.StyleFunction | mapboxgl.Expression | undefined,
    opacity: number
) {
    if (value === undefined) {
        return property === 'opacity' ? opacity : opacity / 2;
    } else if (isNumber(value)) {
        return opacifyNumber(value, opacity);
    } else if (!isArray(value) && value.stops) {
        return {
            ...value,
            stops: value.stops.map(([x, y]) => [x, opacifyNumber(y, opacity)])
        };
    } else if (isArray(value)) {
        return ['*', value, opacity];
    } else {
        return value;
    }
}

function opacifyNumber(number: number, opacity: number) {
    return number * opacity;
}
